import React from 'react';

import styles from './accessCounterLineStyles';

import Icon from 'buyside/components/presentation/Icon/icon';
import AccessModal from './AccessModal/accessModal';

const AccessCounterLine = ({ icon, title, accessData, canWriteIdeas = true }) => {
  if (accessData.isBlocked) {
    return <span />;
  } else {
    return (
      <div className={styles.counterLineWrap}>
        <div>
          <Icon type={icon} style={styles.counterLineIcon} />
        </div>
        <div className={styles.counterLineTitleWrap}>{title}</div>
        {canWriteIdeas ? (
          <AccessModal title={title} accessData={accessData} />
        ) : (
          <span className={styles.ideaDays}>
            {accessData.daysRemaining}
            {Number(accessData.daysRemaining) === 1 ? ' day' : ' days'}
          </span>
        )}
      </div>
    );
  }
};

export default AccessCounterLine;
